<template>
    <bookend-header/>
    <div class="d-flex flex-column h-100">
        <div class="body flex-grow-1 pb-5">
            <div class="container pb-4 gx-2 gx-sm-3">
                <router-view/>
            </div>
        </div>
        <bookend-footer/>
    </div>

</template>

<script>
// @ is an alias to /src
import BookendHeader from '@/components/BookendHeader';
import BookendFooter from '@/components/BookendFooter';

export default {
    name: 'App',
    components: {
        BookendHeader,
        BookendFooter
    }
}
</script>

<style lang="scss">
    @import "src/scss/app";

    body,
    html {
        height:100%
    }

    .body {
        margin-top: 6.9rem;
        background: #163b6f;
        background: linear-gradient(0deg, #08393b 0%, #155f91 50%, #163b6f 100%) fixed;
        background-size: cover;
    }

    //Styles the small breakpoint and smaller.
    @include media-breakpoint-down(sm) {
        .body {
            margin-top: 5.2rem;
        }
    }
</style>
